import * as React from 'react';
import { useMutation } from '@tanstack/react-query';
import { sendValidationMail } from 'services/clients/user';

const SHOW_DURATION = 15 * 1000;

interface Props {
  email: string;
}

export const Resend: React.FC<Props> = (props) => {
  const { email } = props;
  const [sent, setSent] = React.useState(false);
  const timer = React.useRef<number | null>(null);

  React.useEffect(() => {
    return () => {
      if (timer.current) {
        // eslint-disable-next-line
        window.clearTimeout(timer.current);
      }
    };
  });

  const mutation = useMutation(sendValidationMail, {
    onSuccess: () => {
      setSent(true);
      window.setTimeout(() => setSent(false), SHOW_DURATION);
    },
    onError: () => {},
    onMutate: () => {},
  });

  let inner = (
    <p className="cursor-pointer underline" onClick={() => mutation.mutate(email)}>
      Resend verification code
    </p>
  );

  if (mutation.isLoading) {
    inner = <p>Sending…</p>;
  } else if (sent) {
    inner = <p>Verification code sent. Please stay on this page until it is validated.</p>;
  }

  return (
    <h3 className="text-gray-900">
      {inner}
      {mutation.isError && <span className="text-red-900">Could not send verification code.</span>}
    </h3>
  );
};
Resend.displayName = 'EmailConirmation.Resend';
